import React from "react";
import "./MainService.css";
import ServiceItem from "./ServiceItem";
import { motion } from "framer-motion";

// Data for Web Development
const webDevelopment = [
    { title: "UI/UX Design", url: "UI-UX-Design", description: "Modern and optimized user experiences", image: "./img/services/ui-ux.jpg" },
    { title: "Responsive Websites", url: "Responsive-Websites", description: "Works on all devices", image: "./img/services/responsive-website.jpg" },
    { title: "React.js Development", url: "Reactjs-Development", description: "High-performance web apps", image: "./img/services/reactjs.png" },
    { title: "SEO Optimization", url: "SEO-Optimization", description: "Rank higher in search results", image: "./img/services/seo-optimization.jpg" },
    { title: "CMS Solutions", url: "CMS-Solutions", description: "Custom CMS and e-commerce", image: "./img/services/cms-solutions.jpg" },
    { title: "Web Security", url: "Web-Security", description: "Secure and reliable hosting", image: "./img/services/web-security.jpg" },
];

// Data for Artificial Intelligence
const aiServices = [
    { title: "NLP Solutions", url: "NLP-Solutions", description: "Chatbots and language analytics", image: "./img/services/nlp-solutions.jpg" },
    { title: "Computer Vision", url: "Computer-Vision", description: "Image and video analysis", image: "./img/services/compuuter-vision.jpg" },
    { title: "Machine Learning", url: "Machine-Learning", description: "Adaptive ML models", image: "./img/services/machine-learning.jpg" },
    { title: "Data Analytics", url: "Data-Analytics", description: "Business insights through data", image: "./img/services/data-analytics.png" },
    { title: "AI Automation", url: "AI-Automation", description: "Automating workflows", image: "./img/services/ai-automation.jpg" },
    { title: "AI for BI", url: "AI-for-BI", description: "AI-powered decision making", image: "./img/services/ai-for-bi.jpg" },
];

// Data for Dynamics 365
const dynamicsServices = [
    { title: "CRM Solutions", url: "CRM-Solutions", description: "Manage customers and sales", image: "./img/services/crm-solutions.jpg" },
    { title: "Finance Automation", url: "Finance-Automation", description: "Streamline operations", image: "./img/services/finance-automation.png" },
    { title: "Business Central", url: "Business-Central", description: "All-in-one management", image: "./img/services/business-central.png" },
    { title: "Field Service", url: "Field-Service", description: "Optimize on-site services", image: "./img/services/field-service.jpg" },
    { title: "AI Insights", url: "AI-Insights", description: "Predictive analytics", image: "./img/services/ai-insights.jpg" },
    { title: "Customization", url: "Customization", description: "Business-specific workflows", image: "./img/services/customization.jpg" },
];


const MainService = () => {
    return (
        <motion.div
            key="div0"
            initial={{ opacity: 0, x: 100 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: 100 }}
            transition={{ duration: 0.7 }}>
            <ServiceItem title="Web Development" services={webDevelopment} />
            <ServiceItem title="Artificial Intelligence (AI)" services={aiServices} />
            <ServiceItem title="Dynamics 365" services={dynamicsServices} />
        </motion.div>
    );
};

export default MainService;
